import styled from 'styled-components';
import TaskDescription from './component';

export default styled(TaskDescription)`
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 32px;

  .alert-urgent {
    color: var(--error700);
    margin-right: 4px;
    font-weight: bold;
  }

  .alert-moderate {
    color: var(--accent900);
    margin-right: 4px;
    font-weight: bold;
  }

  .margin-right {
    margin-right: 4px;
  }
`;
